var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { forwardRef } from "react";
import { useId } from "./util/useId";
const SvgBooksFill = forwardRef((_a, ref) => {
    var { title, titleId: _titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    let titleId = useId();
    titleId = title ? (_titleId ? _titleId : "title-" + titleId) : undefined;
    return (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: false, role: "img", ref: ref, "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.67 16.335a.75.75 0 0 0-.032-.73l.016.025-.089-.177a3.25 3.25 0 0 1 0-2.906l.089-.177.014-.028a.75.75 0 0 0 .064-.505L17.82 3.23a1.25 1.25 0 0 0-1.22-.979H8.664A2.75 2.75 0 0 0 5.96 4.5l-1.64 8.88c-.046.2-.07.407-.07.62v.032c.01.775.339 1.473.863 1.968A2.75 2.75 0 0 0 7 20.75h12a.75.75 0 0 0 .67-1.085l-.105-.212a3.25 3.25 0 0 1 0-2.906l.106-.212Zm-1.78 2.915a4.75 4.75 0 0 1 0-2.5H7a1.25 1.25 0 1 0 0 2.5h10.89ZM5.75 14.015a1.25 1.25 0 0 0 1.217 1.235H17.89a4.753 4.753 0 0 1 0-2.5H7a1.25 1.25 0 0 0-1.213.947l-.028.15A1.26 1.26 0 0 0 5.75 14v.015ZM9.47 5a.25.25 0 0 0-.247.219l-.188 1.5A.25.25 0 0 0 9.283 7h5.434a.25.25 0 0 0 .248-.281l-.188-1.5A.25.25 0 0 0 14.53 5H9.471Z", fill: "currentColor" })));
});
export default SvgBooksFill;
